import { createContext } from 'react';
import { useLanguagePreferences } from './preferences/useLanguagePreferences';

type LanguagePreferencesState = ReturnType<typeof useLanguagePreferences>;

export interface LanguageContextValue extends LanguagePreferencesState {
  t: (key: string, params?: Record<string, string | number>, fallback?: string) => string;
}

export const LanguageContext = createContext<LanguageContextValue | null>(null);
